<template>
  <form @submit.prevent="submit">
    <div class="row">
      <div class="col-md-3">
        <z-select
          v-model="bodycomp"
          :options="showOptions"
          label="Body Composition"
          @change="saveIt"
        />
      </div>
      <div class="col-md-3">
        <z-select
          v-model="nutrition"
          :options="showOptions"
          label="Nutrition"
          @change="saveIt"
        />
      </div>
      <div class="col-md-3">
        <z-select
          v-model="challenges"
          :options="showOptions2"
          label="Challenges"
          @change="saveIt"
        />
      </div>
      <div class="col-md-3">
        <z-select
          v-model="dashboard"
          :options="showOptions"
          label="Dashboard"
          @change="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <z-select
          v-model="coachwall"
          :options="showOptions"
          label="Coaching"
          @change="saveIt"
        />
      </div>
      <div class="col-md-3">
        <div class="form-group custom-check">
          <input
            type="checkbox"
            id="isLiveStreaming"
            v-model="isLiveStreaming"
            class="z-checkbox-small"
            @click="saveIt"
          />
          <label for="isLiveStreaming" class="custom-allow">live-stream?</label>
        </div>
      </div>
      <div class="col-md-3">
        <z-select
          v-model="assessment"
          :options="showOptions2"
          label="Assessment"
          @change="saveIt"
        />
      </div>
      <div class="col-md-3">
        <z-select
          v-model="progressPhotos"
          :options="showOptions"
          label="Progress Photos"
          @change="saveIt"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <z-input
          v-model="scheduleUrl"
          name="scheduleUrl"
          label="Coach Schedule Url"
          validate="required"
          @keyup="saveIt"
        />
      </div>
      <div class="col-md-4">
        <z-select
          v-model="showUrl"
          :options="showOptions"
          label="Coach Show Url"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group custom-check">
          <input
            type="checkbox"
            id="isBatchIntel"
            v-model="isBatchIntel"
            class="z-checkbox-small"
            @click="saveIt"
          />
          <label for="isBatchIntel" class="custom-allow"
            >uses Batch Intel messaging?</label
          >
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZInput from '@/Components/ZElements/Input'
import ZSelect from '@/Components/ZElements/Select'
export default {
  name: 'organization-config',
  components: {
    ZInput,
    ZSelect,
  },
  data() {
    return {
      showOptions: [
        {
          id: 0,
          name: 'Not Visible',
          value: 0,
        },
        {
          id: 1,
          name: 'Trainers Only',
          value: 1,
        },
        {
          id: 2,
          name: 'Everyone',
          value: 2,
        },
      ],
      showOptions2: [
        {
          id: 0,
          name: 'Not Visible',
          value: 0,
        },
        {
          id: 1,
          name: 'Trainers Only',
          value: 1,
        },
      ],
    }
  },
  computed: {
    ...mapGetters('organizations', ['organization']),
    bodycomp: {
      get() {
        let _data = null
        if (this.organization) {
          _data = this.organization.bodyCompositionVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'bodyCompositionVisibility',
          value: value,
        })
      },
    },
    nutrition: {
      get() {
        let _data = null
        if (this.organization) {
          _data = this.organization.nutritionVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'nutritionVisibility',
          value: value,
        })
      },
    },
    coachwall: {
      get() {
        let _data = null
        if (this.organization) {
          _data = this.organization.coachwallVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'coachwallVisibility',
          value: value,
        })
      },
    },
    challenges: {
      get() {
        let _data = null
        if (this.organization) {
          _data = this.organization.challengesVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'challengesVisibility',
          value: value,
        })
      },
    },
    isLiveStreaming: {
      get() {
        let _data = false
        if (this.organization) {
          _data = this.organization.livestreamVisibility === 1 ? true : false
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'livestreamVisibility',
          value: value ? 1 : 0,
        })
      },
    },
    isBatchIntel: {
      get() {
        let _data = false
        if (this.organization) {
          _data = this.organization.isBatchIntel === 1 ? true : false
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'isBatchIntel',
          value: value ? 1 : 0,
        })
      },
    },
    scheduleUrl: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.coachingScheduleUrl
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'coachingScheduleUrl',
          value: value,
        })
      },
    },
    showUrl: {
      get() {
        let _data = ''
        if (this.organization) {
          _data = this.organization.coachingVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'coachingVisibility',
          value: value,
        })
      },
    },
    assessment: {
      get() {
        let _data = null
        if (this.organization) {
          _data = this.organization.assessmentVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'assessmentVisibility',
          value: value,
        })
      },
    },
    progressPhotos: {
      get() {
        let _data = null
        if (this.organization) {
          _data = this.organization.progressPhotosVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'progressPhotosVisibility',
          value: value,
        })
      },
    },
    dashboard: {
      get() {
        let _data = null
        if (this.organization) {
          _data = this.organization.dashboardVisibility
        }
        return _data
      },
      set(value) {
        this.setOrganizationData({
          name: 'dashboardVisibility',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('organizations', ['setOrganizationData']),
    saveIt() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-check {
  position: relative;
  top: 30px;
}
</style>
